import { useContext } from "react";
import { AuthenticationContext } from "../controls/auth/AuthenticationWrap";

/**
 * Cờ super admin của tài khoản đang đăng nhập — lấy từ /auth/me (users.is_super_admin),
 * đã nằm sẵn trong userInfo sau khi AuthenticationWrap validate xong.
 * `loaded=false` khi chưa validate xong (userInfo từ localStorage KHÔNG lưu cờ này).
 */
export function useIsSuperAdmin(): { isSuperAdmin: boolean; loaded: boolean } {
	const ctx = useContext(AuthenticationContext);
	return {
		isSuperAdmin: ctx?.userInfo?.isSuperAdmin === true,
		loaded: !!ctx?.isFinishedValidate,
	};
}
